// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"df8e8a33","236":"6a2b8ab8","424":"7849e641","453":"7ef5dac4","552":"e08ddc87","632":"73dc3d79","668":"0353d5fe"}[chunkId] + ".chunk.js";
};